<template>
  <v-container fluid class="marketproject-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-project`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Project
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-teams`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Team
          </v-tab>
          <v-tab-item
            :value="'tab-project'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="9"><p class="text-h5">Edit Project</p></v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        type="number"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectnum')"
                        v-bind:value="initvalue.projectnum"
                        placeholder="Project Num"
                        persistent-hint
                        single-line hint="Enter the project num">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=marketprojecttype
                        v-on:change="onChangeProject($event, 'projecttype')"
                        v-bind:value="initvalue.projecttype"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the project type">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectname')"
                        v-bind:value="initvalue.projectname"
                        placeholder="Project Name"
                        persistent-hint
                        single-line hint="Enter the project name">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="pages.map(x => {return {text: x.pagename, value: x._id};})"
                        v-on:change="onChangeProject($event, 'pageid')"
                        v-bind:value="initvalue.pageid"
                        outlined
                        dense
                        placeholder="Page"
                        persistent-hint
                        single-line hint="Please choose the page">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'ad_account_id')"
                        v-bind:value="initvalue.ad_account_id"
                        placeholder="Ad Account Id"
                        persistent-hint
                        single-line hint="Enter the ad account id">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Active', 'Inactive']"
                        :value="initvalue.projectstatus"
                        outlined
                        dense
                        v-on:change="onChangeProject($event, 'projectstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="locations.filter(location=>location.locationstatus=='Active').map(x => {return {text: x.locationname, value: x._id};})"
                        v-on:change="onChangeProject($event, 'locationid')"
                        v-bind:value="initvalue.locationid"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="data_users.filter(user=>user.userstatus=='Active').map(x => {return {text: `${x.username} (${x.companycode})`, value: x._id}})"
                        v-on:change="onChangeProject($event, 'repid')"
                        v-bind:value="initvalue.repid"
                        outlined
                        dense
                        placeholder="Marketing Rep"
                        persistent-hint
                        single-line hint="Please choose the marketing rep">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="brands.filter(brand=>brand.brandstatus=='Active' && brand.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id}})"
                        v-on:change="onChangeProject($event, 'brandid')"
                        v-bind:value="initvalue.brandid"
                        outlined
                        dense
                        placeholder="Brand"
                        persistent-hint
                        single-line hint="Please choose the brand">
                      </v-select>
                      <v-textarea
                        v-on:change="onChangeProject($event, 'projectnote')"
                        v-bind:value="initvalue.projectnote"                        
                        outlined
                        rows=1
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="9">
                    <div class="d-flex justify-center">
                        <v-btn
                            @click="Done"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="updateMarketProject()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            @click="Done"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-teams'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Team Members</p>
                      </v-col>
                      <v-col md="1" align="right">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddMember = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="memberrank"
                        :headers="header_members"
                        :items="data_members"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteMember" width="500">
                            <v-card>
                              <v-card-title> Delete this Member? </v-card-title>
                              <v-card-text>
                                {{ delete_member.membername }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteMember = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteProjectMember(delete_member)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>                    
                        <template v-slot:item.membername="{ item }">
                          <p class="two-line">{{ item.membername }}</p>
                          <p class="two-line">{{ item.membertype }}</p>
                        </template>
                        <template v-slot:item.memberimage="{ item }">
                          <v-img
                            v-if="item.memberimage" 
                            v-bind:src="item.memberimage"
                            max-height="100"
                            max-width="100"
                          ></v-img>
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="editProjectMemberDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteProjectMemberDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        @click="Done"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
    <v-dialog
      v-model="isAddMember"
      persistent
      width="500px"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Member</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="add_member.memberrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="9">
                <v-select
                  class="mb-4"
                  :items="data_users.filter(user=>user.userstatus=='Active').map(x => {
                    return {text: `${x.username} (${x.companycode})`, value: x._id};
                  })"
                  v-on:change="selectUser"
                  v-model="add_member.userid"
                  v-bind:error="errorindex == 3"
                  placeholder="User"
                  dense
                >
                </v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-switch
                  color="primary"
                  v-bind:label="add_member.isLead==true ? 'On': ''"
                  v-model="add_member.isLead"
                  :value="true"
                  :false-value="false"
                  hint="Team Lead"
                  persistent-hint
                ></v-switch>
              </v-col>
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="add_member.membername"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isAddMember=false; add_member={}"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="addProjectMemberRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  <v-row>
    <v-dialog
      v-model="isEditMember"
      persistent
      width="800px"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Member</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberrank')"
                  :value="edit_member.memberrank"
                  class="mb-4"
                  placeholder="Num"
                  type="number"
                  oninput="if(this.value < 0) this.value = 0;"
                  single-line
                  hint="Num"
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <!-- <v-select
                  class="mb-4"
                  :items="teamgroups.map(x => {return {text: x.groupcode, value: x._id};})"
                  v-on:change="onChangeMember($event, 'groupid')"
                  :value="edit_member.groupid"
                  placeholder="Group"
                  dense
                >
                </v-select> -->
              </v-col>
              <v-col cols="12" md="5">
                <!-- <v-select
                  class="mb-4"
                  :items="teamsubgroups.map(x => {
                    return {text: x.subgroupcode, value: x._id};
                  })"
                  v-on:change="onChangeMember($event, 'subgroupid')"
                  :value="edit_member.subgroupid"
                  placeholder="Subgroup"
                  dense
                >
                </v-select> -->
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membername')"
                  :value="edit_member.membername"
                  label="Name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membercode')"
                  :value="edit_member.membercode"
                  label="Code"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-on:change="onChangeMember($event, 'membericon')"
                  :value="edit_member.membericon"
                  label="Icon"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberlink')"
                  :value="edit_member.memberlink"
                  label="Link"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-on:change="onChangeMember($event, 'memberaction')"
                  :value="edit_member.memberaction"
                  label="Action"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="isEditMember=false; edit_member={};"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editProjectMemberRequest"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from '@/Routes';

export default {
  data () {
    return {
      header_members: [
        { text: "#", value: "memberrank", width: "10px" },
        { text: "Image", value: "memberimage", width: "10%"},
        { text: "Name", value: "membername" },
        { text: "Start & End", value: "campaignstartdate", width: "15%" },
        { text: "Status", value: "memberstatus", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      contentHeaders: [
        { text: "#", value: "contentrank", width: "10px" },
        { text: "Image", value: "contentimage", width: "10%"},
        { text: "Member", value: "campaignid", width: "20%" },
        { text: "Title", value: "contenttitle" },
        { text: "Status", value: "contentstatus", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      eventHeaders: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Member", value: "campaignid" },
        { text: "Name & Code", value: "eventname" },
        { text: "Icon", value: "itemicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      jobHeaders: [
        { text: "#", value: "itemrank", width: "10px" },
        { text: "Member", value: "campaignid" },
        { text: "Name & Code", value: "eventname" },
        { text: "Icon", value: "itemicon" },
        { text: "Created", value: "createdAt", width: "10%" },
        { text: "Actions", value: "actions", sortable: false , width: "10%"},
      ],
      initvalue: {},
      marketproject: {},
      data_members: [],
      data_users: [],
      projectcontents: [],
      projectevents: [],
      projectjobs: [],
      pages: [],
      marketprojecttype: ['Branding Project', 'Digital Project', 'Other Project'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      imageurl: undefined,
      new_campaignstartdate: null,
      new_campaignenddate: null,
      new_contentpostdate: null,
      edit_memberstartdate: null,
      edit_memberenddate: null,
      edit_contentpostdate: null,
      new_campaignphoto: null,
      new_contentphoto: null,
      edit_memberphoto: null,
      edit_contentphoto: null,
      photo: {},
      add_member: {},
      add_content: {},
      add_event: {},
      add_job: {},
      edit_member: {},
      edit_content: {},
      edit_event: {},
      edit_job: {},
      change_project: {},
      change_campaign: {},
      change_content: {},
      change_event: {},
      change_job: {},
      delete_member: {},
      delete_content: {},
      delete_event: {},
      delete_job: {},
      isDeleteMember: false,
      isDeleteContent: false,
      isDeleteEvent: false,
      isDeleteJob: false,
      isAddMember: false,
      isAddContent: false,
      isAddEvent: false,
      isAddJob: false,
      isEditMember: false,
      isEditContent: false,
      isEditEvent: false,
      isEditJob: false,
    }
  },
  computed: {
    ...mapState('Brand', ['brands']),
    ...mapState('Location', ['locations']),
    ...mapState('MarketProject', ['isReceiving']),
    ...mapState('MarketPlatform', ['platforms']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('MarketProject', 
    [ 'getMarketProjectsRequest',
      'updateMarketProjectRequest','updateMarketProjectImageRequest',
      'deleteProjectContentRequest', 'deleteProjectEventRequest',
      'insertProjectContentRequest', 'insertProjectEventRequest',
      'updateProjectContentRequest','updateProjectEventRequest' 
    ]),
    ...mapActions('MarketMember', ['deleteProjectMemberRequest', 'insertProjectMemberRequest',
    'insertProjectMemberWithImageRequest', 'updateProjectMemberRequest', 'updateProjectMemberWithImageRequest']),
    ...mapActions('MarketContent', ['deleteProjectContentRequest', 'insertProjectContentRequest',
    'insertProjectContentWithImageRequest', 'updateProjectContentRequest', 'updateProjectContentWithImageRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('MarketPlatform', ['getMarketPlatformsRequest']),
    ...mapActions('User', ['getUsersMarketProjectRequest']),
    Done() {
      if(this.initvalue._isFrom!==undefined) this.$router.replace({ name: this.initvalue._isFrom });
      else this.$router.replace({ name: 'MarketProjectTeamList' });
    },
    selectUser(item){
      let user = this.data_users.find(user=>user._id==item);
      this.add_member = Object.assign({}, this.add_member, {membername: user.username});
    },
    async addProjectMemberRequest() {
      this.isAddMember = false;
      this.add_member.projectid = this.initvalue._id;
      let result = await this.insertProjectMemberRequest(this.add_member);
      this.data_members.push(result);
      this.add_member = {};
    },
    async addProjectContentRequest() {
      let result;
      this.isAddContent = false;
      this.add_content.projectid = this.initvalue._id;
      if(this.add_content.imagefile!==null && this.add_content.imagefile!==undefined) result = await this.insertProjectContentWithImageRequest(this.add_content);
      else result = await this.insertProjectContentRequest(this.add_content);
      this.projectcontents.push(result);
      this.add_content = {};
      this.new_contentphoto = null;
    },
    async addProjectEventRequest() {
      this.isAddEvent = false;
      this.add_event.projectid = this.initvalue._id;
      let result = await this.insertProjectEventRequest(this.add_event);
      this.projectevents.push(result);
      this.add_event = {};
    },
    async addProjectJobRequest() {
      this.isAddJob = false;
      this.add_job.projectid = this.initvalue._id;
      let result = await this.insertProjectJobRequest(this.add_job);
      this.projectjobs.push(result);
      this.add_job = {};
    },
    deleteProjectMemberDialog(item) {
      this.isDeleteMember = true;
      this.delete_member = { _id: item._id, membername: item.membername };
    },
    deleteProjectContentDialog(item) {
      this.isDeleteContent = true;
      this.delete_content = { _id: item._id, contenttitle: item.contenttitle };
    },
    deleteProjectEventDialog(item) {
      this.isDeleteEvent = true;
      this.delete_event = { _id: item._id, eventname: item.eventname };
    },
    deleteProjectJobDialog(item) {
      this.isDeleteJob = true;
      this.delete_job = { _id: item._id, jobname: item.jobname };
    },
    async deleteProjectMember(payload) {
      this.isDeleteMember = false;
      let response = await this.deleteProjectMemberRequest(payload);
      console.log('1234', response)
      let index = this.data_members.findIndex((trans) => trans._id == response._id);
      this.data_members.splice(index, 1);
    },
    async deleteProjectContent(payload) {
      this.isDeleteContent = false;
      let response = await this.deleteProjectContentRequest(payload);
      console.log('1234', response)
      let index = this.projectcontents.findIndex((trans) => trans._id == response._id);
      this.projectcontents.splice(index, 1);
    },
    async deleteProjectEvent(payload) {
      this.isDeleteEvent = false;
      let response = await this.deleteMarketProjectItemRequest(payload);
      let index = this.projectevents.findIndex((trans) => trans._id == response._id);
      this.projectevents.splice(index, 1);
    },
    async deleteProjectJob(payload) {
      this.isDeleteJob = false;
      let response = await this.deleteProjectJobRequest(payload);
      let index = this.projectjobs.findIndex((trans) => trans._id == response._id);
      this.projectjobs.splice(index, 1);
    },
    editProjectMemberDialog(item) {
      let dates = {
        campaignstartdate: formatStdDate(item.campaignstartdate),
        campaignenddate: formatStdDate(item.campaignenddate),
      }
      this.edit_member = Object.assign({}, item, dates);
      this.change_campaign = {};
      this.isEditMember = true;
    },
    editProjectContentDialog(item) {
      this.edit_content = Object.assign({}, item);
      this.change_content = {};
      this.isEditContent = true;
    },
    editProjectEventDialog(item) {
      this.edit_event = Object.assign({}, item);
      this.change_event = {};
      this.isEditEvent = true;
    },
    editProjectJobDialog(item) {
      this.edit_job = Object.assign({}, item);
      this.change_job = {};
      this.isEditJob = true;
    },
    async updateMarketProject() {
      this.change_project._id = this.initvalue._id;
      await this.updateMarketProjectRequest(this.change_project);
      this.Done();
    },
    async editProjectMemberRequest() {
      this.isEditMember = false;
      this.change_campaign.campaignid = this.edit_member._id;
      let response;
      if(this.change_campaign.imagefile!==null && this.change_campaign.imagefile!==undefined) response = await this.updateProjectMemberWithImageRequest(this.change_campaign);
      else response = await this.updateProjectMemberRequest(this.change_campaign);
      let index = this.data_members.findIndex((x) => x._id == response._id);
      this.data_members.splice(index, 1, response);
      this.edit_member = {};
      this.edit_memberphoto = null;
    },
    async editProjectContentRequest() {
      this.isEditContent = false;
      this.change_content.marketprojectsubgroupid = this.edit_content._id;
      let response = await this.updateProjectContentRequest(this.change_content);
      let index = this.projectcontents.findIndex((x) => x._id == response._id);
      this.projectcontents.splice(index, 1, response);
      this.edit_content = {};
    },
    async editProjectEventRequest() {
      this.isEditEvent = false;
      this.change_event.marketprojectitemid = this.edit_event._id;
      let response = await this.updateProjectEventRequest(this.change_event);
      let index = this.projectevents.findIndex((x) => x._id == response._id);
      this.projectevents.splice(index, 1, response);
      this.edit_event = {};
    }, 
    async editProjectJobRequest() {
      this.isEditJob = false;
      this.change_job.marketprojectitemid = this.edit_job._id;
      let response = await this.updateProjectJobRequest(this.change_job);
      let index = this.projectjobs.findIndex((x) => x._id == response._id);
      this.projectjobs.splice(index, 1, response);
      this.edit_job = {};
    },
    editPhoto() {
      this.photo._id = this.initvalue._id;
      this.updateMarketProjectImageRequest(this.photo);
      router.push('/marketproject/list');
    },
    createImage(file) {
      const reader = new FileReader();
      reader.onload = e => this.imageurl = e.target.result;
      reader.readAsDataURL(file);
    },  
    onFileChange(file) {
      if (!file) return;
      this.photo.imagefile = file;
      this.photo.imagename = file.name;
      this.createImage(file);
    },
    onChangeMemberPhoto(file) {
      if (!file) return;
      this.add_member.imagefile = file;
      this.add_member.imagename = file.name;
    },
    onChangeContentPhoto(file) {
      if (!file) return;
      this.add_content.imagefile = file;
      this.add_content.imagename = file.name;
    },
    onChangeMemberEditPhoto(file) {
      if (!file) return;
      this.change_campaign.imagefile = file;
      this.change_campaign.imagename = file.name;
    },
    onChangeProject(value, field){
      this.change_project[field] = value;
    },
    onChangeMember(value, field){
      this.change_campaign[field] = value;
    },
    onChangeContent(value, field){
      this.change_content[field] = value;
    },
    onChangeEvent(value, field){
      this.change_event[field] = value;
    },  
    onChangeJob(value, field){
      this.change_job[field] = value;
    },     
  },

  async created () {
    this.initvalue = this.$route.params;
    this.data_members = this.initvalue.members;
    this.projectcontents = this.initvalue.contents;
    this.projectevents = this.initvalue.items;
    this.imageurl = this.initvalue.projectimage;
    if(!this.initvalue._id) this.$router.push({ name: 'MarketProjectList' });
    
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.platforms.length==0) await this.getMarketPlatformsRequest();
    this.data_users = await this.getUsersMarketProjectRequest();

    for(var platform of this.platforms){
      this.pages = [...this.pages, ...platform.pages];
    }

  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
